import { useEffect } from 'react'
import { useTranslationJobsStore } from '@/entities/localized-speech'
import { TRANSLATION_JOB_STATUS } from '@/shared/constants/status'

// ? VI: Input không có tham số. | EN: Input has no arguments.
// ? VI: Output đăng ký/hủy đăng ký cảnh báo beforeunload của browser. | EN: Output registers/unregisters browser beforeunload warning.
// * VI: Ngăn đóng tab nhầm khi còn job nền đang chạy. | EN: Prevent accidental tab close while background jobs are running.
export function useTranslationJobsBeforeUnload() {
  const hasRunningJobs = useTranslationJobsStore((state) =>
    state.jobs.some((job) => job.status === TRANSLATION_JOB_STATUS.PROCESSING),
  )

  useEffect(() => {
    // * VI: Chỉ bật guard khi còn ít nhất 1 job nền đang chạy. | EN: Guard unload only when at least one long-running job is active.
    if (!hasRunningJobs) {
      return
    }

    function handleBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [hasRunningJobs])
}
